import { Injectable, Inject, InjectionToken } from '@angular/core';
import type { FontInfo } from 'estensa-module';
import { from, noop } from 'rxjs';

export const ESTENSA_MODULE_RECONICE_SERVICE = new InjectionToken('estensa.module.reconice.service');

export interface IRecomedConfigurationServiceNg1 {

    asyncRecomedLogon(
        userName: string,
        pwd: string,
        group: string,
    ): { $promise: Promise<any> };

    asyncRecomedLogoff(): { $promise: Promise<any> };

    isRecomedConnectedAndLoggedOn(): boolean;

    setEstensaUserLoginStatus(
        isLogged: boolean,
    ): void;

    setDefaultVisibleButton(): void;

    setTextEditorButtonVisibility(editorConfig: Array<string>): void;

    setFont(
        fontInfo: FontInfo | null,
    ): void;

    initReconice(): void;

}

@Injectable({
    providedIn: 'root',
})
export class NullReconiceService implements IRecomedConfigurationServiceNg1 {
    asyncRecomedLogon(): { $promise: Promise<any>; } {
        return {
            $promise: Promise.resolve(null),
        };
    }

    asyncRecomedLogoff(): { $promise: Promise<any>; } {
        return {
            $promise: Promise.resolve(null),
        };
    }

    isRecomedConnectedAndLoggedOn() {
        return false;
    };

    setEstensaUserLoginStatus = noop;

    setFont = noop;

    setDefaultVisibleButton = noop;
    setTextEditorButtonVisibility = noop;

    initReconice = noop;
}

@Injectable({
    providedIn: 'root',
})
export class EstensaReconiceService {
    constructor(
        @Inject(ESTENSA_MODULE_RECONICE_SERVICE) private recomedConfigurationService: IRecomedConfigurationServiceNg1,
    ) {
    }

    asyncRecomedLogon(userName: string, pwd = null, group = null) {
        return from(
            this.recomedConfigurationService.asyncRecomedLogon(userName, pwd, group).$promise,
        );
    }

    asyncRecomedLogoff() {
        return from(
            this.recomedConfigurationService.asyncRecomedLogoff().$promise,
        );
    }

    isRecomedConnectedAndLoggedOn() {
        return this.recomedConfigurationService.isRecomedConnectedAndLoggedOn();
    }

    setEstensaUserLoginStatus(isLogged: boolean) {
        return this.recomedConfigurationService.setEstensaUserLoginStatus(isLogged);
    }

    setFont(fontInfo: FontInfo | null) {
        /*@TODO fontInfo non viene usato nella chiamata qui sotto*/
        return this.recomedConfigurationService.setFont(fontInfo);
    }

    setDefaultVisibleButton() {
        return this.recomedConfigurationService.setDefaultVisibleButton();
    }

    setTextEditorButtonVisibility(editorConfig: Array<string>) {
        return this.recomedConfigurationService.setTextEditorButtonVisibility(editorConfig);
    }

    initReconice() {
        return this.recomedConfigurationService.initReconice();
    }

}
